export const getReadableFileType = (file: File) => {
    const mime = file.type;
    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!mime && !extension) return 'Desconocido';

    // Mapas comunes basados en MIME o extensión
    if (mime.includes('image/') || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension!)) {
        return 'Imagen';
    }

    if (mime.includes('video/') || ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'webm', 'wma'].includes(extension!)) {
        return 'Video';
    }

    if (mime === 'application/pdf' || extension === 'pdf') {
        return 'Documento Pdf';
    }

    if (mime === 'text/csv' || extension === 'csv') {
        return 'Csv';
    }

    if (
        mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        mime === 'application/vnd.ms-excel' ||
        ['xls', 'xlsx'].includes(extension!)
    ) {
        return 'Excel';
    }

    if (
        mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        mime === 'application/msword' ||
        ['doc', 'docx'].includes(extension!)
    ) {
        return 'Word';
    }

    if (
        mime === 'application/vnd.ms-powerpoint' ||
        mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
        ['ppt', 'pptx'].includes(extension!)
    ) {
        return 'Power Point';
    }

    if (mime === 'text/plain' || extension === 'txt') {
        return 'Documento de texto';
    }

    return 'Otro';
};

export const formatFileSize = (sizeInBytes: number): string => {
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let size = sizeInBytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size = size / 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
};